import React from 'react';

export default class Loading extends React.Component{
    constructor(){
        super();
    }
    render(){
        return (
            <div></div>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/asyncComps/Loading.js